import React, { memo, useCallback } from 'react';
import { FormSelect } from '@core/components/form';
import { useBloc } from '@core/utils/bloc';
import { PolicyWidgetForm, PolicyBlockVariation } from './PolicyBlock';
import { PolicyBlockBloc } from './PolicyBlockBloc';
import { CompactLibraryItemResponse, LibraryItemOptionResponse } from '@business/entities/library';
import { useLibraryItemSelect } from '../Common/LibraryItemSelect';

export interface EmbedBlockSettingsProps {
  form: PolicyWidgetForm;
  variation: PolicyBlockVariation;
}

export const PolicyBlockSettings = memo((props: EmbedBlockSettingsProps) => {
  const { form, variation } = props;
  const bloc = useBloc(PolicyBlockBloc, variation);

  const apply = useCallback(
    (item: CompactLibraryItemResponse, policy: LibraryItemOptionResponse) => {
      try {
        const json = JSON.parse(item.content as string);
        form.patchValue({ text: json[0], heading: policy.name });
      } catch (e) {
        form.patchValue({ text: item.content as string, heading: policy.name });
      }
    },
    [form],
  );

  const { items, onChange, noOptionsMessage } = useLibraryItemSelect(bloc, form.controls.id, 'policies', apply);

  return (
    <div>
      <FormSelect control={form.controls.id} items={items} onChange={onChange} noOptionsMessage={noOptionsMessage} />
    </div>
  );
});
